var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.28 32.72c-7.58 0-13.78 6.2-13.78 13.76s6.2 13.78 13.78 13.76 13.78-6.2 13.78-13.76-6.2-13.78-13.78-13.76z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.88 38.7v6.98c0 0.4 0.4 1.02 1.02 1h4.98",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.32 42.7h-23.74c-1.8 0-3.2-1.38-3.2-3.2v-29.12c0-1.8 1.38-3.2 3.2-3.2h33.32c1.8 0 3.2 1.38 3.2 3.2v19.74",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1 20.34h-39.7",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.98 2.8v8.78",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32 2.8v8.78",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.38 27.32c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2 0-0.8 0.4-1.2 1.2-1.2 0.8 0 1.2 0.58 1.2 1.2z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.34 27.32c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2 0-0.8 0.4-1.2 1.2-1.2 1.02 0 1.2 0.58 1.2 1.2z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.38 35.7c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2s0.4-1.2 1.2-1.2 1.2 0.58 1.2 1.2z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.34 35.7c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2s0.4-1.2 1.2-1.2c1.02 0 1.2 0.58 1.2 1.2z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.52 27.32c0 0.58-0.4 1.2-1.2 1.2s-1.2-0.58-1.2-1.2 0.4-1.2 1.2-1.2c0.8 0 1.2 0.58 1.2 1.2z",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.a0d6c7c16d8f818a1c6ba7703a6829f9.svg";
export { ForwardRef as ReactComponent };